import { SurchargeOption } from 'components/admin-portal/Tables/Employer/SurchargeRelations/types';

export const surchargeSelectValueFormatter = (
  value: string | number,
  options: SurchargeOption[]
) => {
  const option = options?.find((options) => options.surchargeId === value);
  return option?.label;
};
